import { escapeHtml } from './pasteUtils/htmlEscape';
import {
  convertBraceVarsToPills,
  pillRefFromTag,
  refreshVariableHtml,
} from './variableUtils';

/** Plain formula (`{{qty}} * 2`) → HTML with variable pills. */
export const formulaToHtml = (expr, resolveVariable) => {
  const text = String(expr ?? '');
  if (!text) return '';
  const escaped = escapeHtml(text).replace(/\n/g, '<br>');
  return refreshVariableHtml(convertBraceVarsToPills(escaped), resolveVariable);
};

/** Contenteditable formula field → stored `{{name}}` string. */
export const formulaFromElement = (root) => {
  if (!root) return '';
  let out = '';
  const walk = (node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      out += (node.textContent || '').replace(/\u200B/g, '').replace(/\u00a0/g, ' ');
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.hasAttribute?.('data-doc-variable')) {
      const ref = pillRefFromTag(node);
      if (ref) out += `{{${ref}}}`;
      return;
    }
    if (node.tagName === 'BR') {
      out += '\n';
      return;
    }
    node.childNodes.forEach(walk);
  };
  root.childNodes.forEach(walk);
  return out.replace(/\u00a0/g, ' ');
};
